<template>
  <div class="flex flex-col ">
    <div class="flex justify-between w-full items-center mx-auto">
      <div class="flex items-center">
        <div class="cursor-pointer" @click="$router.push('/')">
          <a href="/">
          <img class="h-4 md:h-auto" src="@/assets/SVG/logo_black.svg"/>
          </a>
        </div>
        <!-- <StubCity></StubCity> -->
      </div>
      <div class="mr-2 items-center hidden md:inline-block text-sm z-50 relative">
        <div>
           <nav class="-mx-2 flex items-center justify-between whitespace-no-wrap">
                      <a
                   href="https://party.mozgo.com/"
                   class="text-main-text mx-2 hover:opacity-75 no-underline opacity-100 font-bold outline-none"
                   style="transition: all 0.5s"
                 >MozgoParty</a>
                     <a href="https://partners.mozgo.com/?utm_source=mozgocom" class="">
                 <button
                   class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none"
                   style="transition: all 0.5s"
                 >Купить франшизу</button> </a>
                 <a
                   href="https://corp.mozgo.com?utm_source=mozgo"
                   class="text-main-text mx-2 hover:opacity-75 opacity-100 font-bold outline-none no-underline"
                   style="transition: all 0.5s"
                 >Заказать корпоратив</a>

                 <UserModal @logout="$emit('logout')" @registration_open="$emit('auth')"></UserModal>
               </nav>
             </div>
           </div>
      <div class="flex justify-end flex-col relative  md:hidden">
        <img class=" md:hidden w-6 h-6 ml-auto mr-0"
             src="@/assets/SVG/burger-dark.svg" alt=""
             @click.prevent="desktop_menu = $event.target"/>
      </div>
    </div>
      <desktop-menu v-if="desktop_menu" @close="desktop_menu = false" @logout="$emit('logout')" @registration_open="$emit('auth')" class="lg:hidden"></desktop-menu>
        </div>
        </template>
<script>
import UserModal from './user-modal';
import DesktopMenu from '../views/home-page-layouts/components/desktop-menu';
import StubCity from '../views/stub/stub_city';
import ClientNav from '../views/players/user-nav-mobile';


export default {
  name: 'moz-header',
  components: {
    StubCity,
    DesktopMenu,
    UserModal,
    ClientNav,
  },
  data() {
    return {
      desktop_menu: false,

    };
  },
  methods: {
    openMainPageNewTabOnRightClick() {
      window.open('https://portal.mozgo.com', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
  .toParty {

    border-radius: 5px;
    padding: 10px;
  }
  .router-link-active {
  @apply .border-b-2 .border-yellow;
  }

  @media only screen and (max-width: 760px) {
    .toParty {
      background-color :rgba(218, 218, 218, 0.2);
    }
    .container {
      max-width: 95%;
    }

  }

  @media only screen and (min-width: 768px) and (max-width: 1270px) {
    .container {
      max-width: 80%;
    }
  }

  @media only screen and (min-width: 1280px) {
    .container {
      max-width: 80%;
    }
  }

</style>
